// extracted by mini-css-extract-plugin
export default {"addCreditsButton":"GoldShinyButton_addCreditsButton__mDvJW"};